import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import type { PropType } from 'vue'
  import type { CourseProgress } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MultipleProgressBar',
  props: {
    progressBarOptions: {
      type: Array as PropType<CourseProgress[]>,
      required: true,
    },
    totalQuestions: {
      type: Number,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  

  const progressBarSize = computed(() => props.progressBarOptions.length)
  const progressBarName = computed(() => {
    return (index: number) => props.progressBarOptions[index].name
  })
  const progressBarPercentage = computed(() => {
    return (index: number) => props.progressBarOptions[index].percentage
  })

  const barWidth = (index: number) => {
    return Math.ceil((props.progressBarOptions[index - 1].totalPartQuestions / props.totalQuestions) * 300)
  }

return { __sfc: true,props, progressBarSize, progressBarName, progressBarPercentage, barWidth, computed }
}

})